import { TreeNodeFile } from '@/entities/Tree';
import { TreeStore } from '@/stores/local/shared/TreeStore';

export const findTreeFileNode = (store: TreeStore, targetId: string): TreeNodeFile | null => {
  const data = store.data;

  if (data?.type === 'file' && String(data.id) === targetId) {
    return data;
  }

  for (const child of store.children) {
    const found = findTreeFileNode(child, targetId);

    if (found) {
      return found;
    }
  }

  return null;
};

export const findDocumentName = (store: TreeStore, targetId: string): string | null => {
  if (String(store.data.id) === targetId) {
    return store.data.name ?? null;
  }

  for (const child of store.children) {
    const name = findDocumentName(child, targetId);

    if (name) {
      return name;
    }
  }

  return null;
};

export const findDocumentContentType = (store: TreeStore, targetId: string): string | null => {
  if (String(store.data.id) === targetId) {
    return store.data.type === 'file' ? store.data.contentType : null;
  }

  for (const child of store.children) {
    const ct = findDocumentContentType(child, targetId);

    if (ct !== null) {
      return ct;
    }
  }

  return null;
};
